import enCA from "../../intl/en-CA";
import frCA from "../../intl/fr-CA";
import React from "react";
import BSModal from "../BSModal";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { EN } from "../../../components/common/enums/languages";

const handleExtraDataErrors = (errorObjPath, extraData) => {
	let errorsStrArr = new Set();

	let emptyPolicyNumberGuarantees = [];
	let badPolicyNumberGuarantees = [];
	let manualBillingPeriodsErrors = [];
	let emptyExternalDivisionNumberErrors = [];
	let emptyExternalClassNumberErrors = [];

	/**
		* Create arrays of all guarantees
		*/

	extraData.forEach((err) => {
		if (err.hasOwnProperty("emptyPolicyNumber")) {
			emptyPolicyNumberGuarantees.push(err["emptyPolicyNumber"]);
		}

		else if (err.hasOwnProperty("badlyConfiguredPolicyNumber")) {
			badPolicyNumberGuarantees.push(err["badlyConfiguredPolicyNumber"]);
		}

		else if (err.hasOwnProperty("misconfiguredManualBillingPeriods")) {
			manualBillingPeriodsErrors.push(...err["misconfiguredManualBillingPeriods"]);
		}
		else if (err.hasOwnProperty("emptyExternalDivisionNumber")) {
			emptyExternalDivisionNumberErrors.push(err["emptyExternalDivisionNumber"]);
		}
		else if (err.hasOwnProperty("emptyExternalClassNumber")) {
			emptyExternalClassNumberErrors.push(err["emptyExternalClassNumber"]);
		}
	});

	/**
		* Create error strings
		*/

	if (emptyPolicyNumberGuarantees.length > 0) {
		errorsStrArr.add(errorObjPath["emptyPolicyNumber"].replace("{}", `\n${emptyPolicyNumberGuarantees.join(', ')}\n`));
	}

	if (badPolicyNumberGuarantees.length > 0) {
		errorsStrArr.add(errorObjPath["badlyConfiguredPolicyNumber"].replace("{}", `\n${badPolicyNumberGuarantees.join(', ')}\n`));
	}

	if (manualBillingPeriodsErrors.length > 0) {
		const userLanguage = localStorage.getItem("languageCode") || EN.value;
		let stringToDisplay = "";

		manualBillingPeriodsErrors.forEach((bp) => {
			if (bp.hasOwnProperty("languageCode") && bp.languageCode === userLanguage) {
				if (stringToDisplay) {
					stringToDisplay += ", ";
				}
				stringToDisplay += `${bp["name"]}`;
			}
		});

		if (stringToDisplay.length > 0) {
			errorsStrArr.add(errorObjPath["misconfiguredManualBillingPeriods"].replace("{}", `${stringToDisplay}\n`));
		}
	}

	if (emptyExternalDivisionNumberErrors.length > 0) {
		errorsStrArr.add(errorObjPath["emptyExternalDivisionNumber"].replace("{}", `\n${emptyExternalDivisionNumberErrors.join(', ')}\n`));
	}
	if (emptyExternalClassNumberErrors.length > 0) {
		errorsStrArr.add(errorObjPath["emptyExternalClassNumber"].replace("{}", `\n${emptyExternalClassNumberErrors.join(', ')}\n`));
	}

	return errorsStrArr;
};

export const errorCodesToErrors = (errorsArr, userLanguage, errorPath, extraData) => {
	let translationFile = userLanguage == EN.value ? enCA : frCA;
	let errorsStrSet = new Set();
	const errorObjPath = errorPath.split("/").reduce((prev, cur) => prev[cur], translationFile);

	if (extraData) {
		errorsStrSet = handleExtraDataErrors(errorObjPath, extraData);
	}
	/**
		* Reducer function to concat object paths and return the path where we can access the object in the for loop below.
		*/
	for (let i = 0; i < errorsArr.length; i++) {
		let errorCodeName = errorsArr[i];
		if (typeof errorCodeName === 'string') {
			/**
				* If errorCodeName is == to a dict, it's a special exception that we 
			 * don't treat here. In this block we just treat simple error codes that are sent from API.
				*/
			errorsStrSet.add(errorObjPath[errorCodeName]);
		}
	}
	return Array.from(errorsStrSet);
};

export const getSingleErrorFromCode = (errorCode, userLanguage, errorPath) => {
	let translationFile = userLanguage == EN.value ? enCA : frCA;
	const errorObjPath = errorPath.split("/").reduce((prev, cur) => prev[cur], translationFile);
	return errorObjPath[errorCode];
};

export const getParsedErrors = (serverMessage, userLanguage, errorPath, extraData = undefined) => {
	serverMessage = JSON.parse(serverMessage.replace(/'/g, '"')); //replacing all ' with " for json parsing (transform to array obj.)
	let errorCodesToString = errorCodesToErrors(serverMessage, userLanguage, errorPath, extraData).join("\r\n");

	return errorCodesToString;
};

export const renderErrorModal = (showModalState, onClose, errorsString, errorMsgId, actionType = undefined) => {
	return (
		<BSModal
			show={showModalState}
			title={
				<FormattedMessage id="validation.clientFieldValidation.attention">
					{(f) => <span className="icon warning">{f}</span>}
				</FormattedMessage>
			}
			onClose={onClose}
		>
			<div className="modal-spacing-break">
				<span className="danger">
					<FormattedMessage id={errorMsgId} values={{ actionType: actionType, br: <br /> }} />
				</span>
				<span>{errorsString}</span>
			</div>
		</BSModal>
	);
};

export const renderSuccessModal = (
	showModalState,
	onClose,
	titleMsgId,
	bodyMsgId,
	titleValueObj = {},
	bodyValueObj = {}
) => {
	return (
		<BSModal
			show={showModalState}
			title={
				<FormattedHTMLMessage id={titleMsgId} values={titleValueObj}>
					{(f) => (
						<div className="flex flex-row">
							<div className="icon-container">
								<span className="icon icon-checkmark approve-icon"/>
							</div>
							<span className="success-message">{f}</span>
						</div>
					)}
				</FormattedHTMLMessage>
			}
			onClose={onClose}
		>
			<FormattedMessage id={bodyMsgId} values={bodyValueObj} />
		</BSModal>
	);
};

export const renderConfirmationModal = (showModalState, onConfirm, onClose, formattedMessage) => {
	return (
		<BSModal
			show={showModalState}
			title={
				<FormattedMessage id="validation.clientFieldValidation.attention">
					{(f) => <span className="icon warning">{f}</span>}
				</FormattedMessage>
			}
			actions={[
				{
					id: 1,
					text: <FormattedMessage id="common.confirm" />,
					action: onConfirm,
				},
			]}
			onClose={onClose}
		>
			<div className="modal-spacing">
				<span>{formattedMessage}</span>
			</div>
		</BSModal>
	);
};



// WEBPACK FOOTER //
// ./src/components/common/form/FieldErrorHelper.js